// extracted by mini-css-extract-plugin
module.exports = {"will__change":"simple-form_will__change__srq3Q","simpleForm":"simple-form_simpleForm__sL3nX"};